export const DownloadImageApi =  (imageAddres) => {
  const url = `https://file.shabinja.com/api/v1/file/Download?path=${imageAddres}`;
  return url;
};


export const handleImageUrl=(imageAddress) => {
  return `https://file.shabinja.com/api/v1/file/Download?path=${imageAddress}`;
}